<template>
  <div id="access-facility-information">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
    </header>
    <!-- main -->
    <main>
      <section>
        <div class="l-shop l-shop--dark-grey pt-0">
          <div class="l-shop__head l-shop__head--pd pt-12">
            <div v-on:click="backPagePrevious" class="l-shop__head--icon">
              <img src="/assets/images/icon/icon-back.svg" alt="">
            </div>
            <div class="l-shop__head--title l-shop__head--auto">アクセス</div>
            <div class="l-shop__head--icon"></div>
          </div>
        </div>
      </section>
      <iframe class="iframe nomargin" :src="accessUrl" width="100%"></iframe>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import { getShop } from "../store/firestore";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "StoreLocationNoHeader",
  components: {
    PopAlert
  },
  mixins: [Tenant],
  async created(){
    const shopId = this.$route.params.shopId;
    if (!shopId) {
      this.$router.push("/");
    } else {
      const shop = await getShop(shopId);
      this.accessUrl = shop.accessUrl;
    }
  },
  data(){
    return {
      accessUrl: null
    }
  },
  mounted() {
    Common.initDom();
  }
});
</script>